import React, { Component } from "react";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Modal,
} from "reactstrap";
import base64 from "base-64";
import { Redirect } from "react-router-dom";
import config from "../../../config";
import LoginError from "../../../components/LoginError/LoginError";
import Select from "react-select";
import RequestManager from "../../../singletons/RequestManager";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../../utils/helper";
class Login extends Component {
  constructor(props) {
    super(props);
    this.email = "";
    this.password = "";

    this.state = {
      loginModalVisible: false,
      loginErrorMessage: "",
      activeorders: false,
      showLogin: false,
      showStores: false,
      stores: null,
      selectedStores: [],
      selectedStoreID: "",
    };
  }
  componentDidMount() {}
  render() {
    let storeDetails = localStorage.getItem("storeInformation");

    if (!!storeDetails) {
      return <Redirect to="/"></Redirect>;
    } else {
      return (
        <div>
          {this.state.showLogin === true ? (
            this.renderLoginForm()
          ) : (
            <div className="app flex-row align-items-center">
              <Container>
                <Modal
                  size="lg"
                  isOpen={this.state.loginModalVisible}
                  toggle={this.toggleErrorLoginModal}
                >
                  <LoginError
                    editable={true}
                    loginErrorMessage={this.state.loginErrorMessage}
                    goBack={this.toggleErrorLoginModal}
                  />
                </Modal>
                <Row className="justify-content-center">
                  <Col md="6">
                    <CardGroup>
                      <Card className="p-4">
                        <CardBody>
                          <h1>Business Dasboard</h1>
                          <p className="text-muted">
                            Sign in with your GrabbnGo Store account
                          </p>

                          <Row>
                            <Col xs="6">
                              <Button
                                color="primary"
                                className="px-4"
                                onClick={() => {
                                  this.startClick();
                                }}
                              >
                                Start
                              </Button>
                            </Col>
                            <Col xs="6" className="text-right">
                              {/* <Button color="link" className="px-0">Forgot password?</Button> */}
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </CardGroup>
                  </Col>
                </Row>
              </Container>
            </div>
          )}
        </div>
      );
    }
  }

  resetpassword = () =>{
    
    localStorage.setItem("resetpwd", true);
    console.log('resetpwd', localStorage.getItem('resetpwd'))
    this.props.history.push("/storeuserregistration");
  }

  startClick = () => {
    let storeDetails = localStorage.getItem("storeInformation");
    let gngloginMode = localStorage.getItem("gngloginMode");
    let gngtoken = localStorage.getItem("gngtoken");
// Peri VAPT comment
    // console.log("gngtokenappstart", gngtoken);
    // console.log("gngloginModeappstart", JSON.stringify(gngloginMode));
    let gngstoreemailid = localStorage.getItem("gngstoreemailid");
    if (
      gngtoken !== null &&
      gngstoreemailid !== null &&
      gngstoreemailid !== undefined &&
      gngstoreemailid !== "undefined"
    ) {
// Peri VAPT comment
      // console.log("gngtokeninside", gngtoken);
      // console.log("gngstoreemailidapp", gngstoreemailid);
      // console.log("gngtokenappstart", gngtoken);
      this.email = gngstoreemailid;
      let gngstorepassword = localStorage.getItem("gngstorepassword");
      this.password = gngstorepassword;
      this.submitCredentials();
    } else if (storeDetails !== null) {
       let loginMode = localStorage.getItem("loginMode");
        let storeInformation = JSON.parse(localStorage.getItem("storeInformation") || "{}");
      
        if (
          loginMode === "store" &&
          storeInformation.store &&
          storeInformation.store.foodcourtCashier === true
        ) {
          //  console.log("foodcourt in login.js line -145")
          this.props.history.push("/activecashorders");
          
        } else {
          // console.log("foodcourt in login.js line 145")
          this.props.history.push("/activeorders");
        }
      // this.props.history.push("/activeorders"); Peri commented to enable active cash orders for foodcourt login
    } else {
      console.log("gngtokenLoginshow", "true");
      this.setState({ showLogin: true });
    }
  };
  renderLoginForm = () => {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Modal
            size="lg"
            isOpen={this.state.loginModalVisible}
            toggle={this.toggleErrorLoginModal}
          >
            <LoginError
              editable={true}
              loginErrorMessage={this.state.loginErrorMessage}
              goBack={this.toggleErrorLoginModal}
            />
          </Modal>
          {this.state.showStores === false ? (
            <Row className="justify-content-center">
              <Col md="6">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>Business Dasboard</h1>
                      <p className="text-muted">
                        Sign in with your GrabbnGo Store account
                      </p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="Email/PhoneNumber"
                          onChange={(event) => {
                            this.email = event.target.value;
                          }}
                        />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          placeholder="Password"
                          onChange={(event) => {
                            this.password = event.target.value;
                          }}
                        />
                      </InputGroup>
                      <Row>
                        <Col >
                          <Button
                            color="primary"
                            className="px-4"
                            onClick={this.submitCredentials}
                          >
                            Login
                          </Button>
                        </Col>
                        {/* <Col >
                           <Button color="primary" className="px-2" onClick={this.resetpassword}>Reset.Password</Button> 
                           
                        </Col> */}
                      </Row>
                    </CardBody>
                  </Card>
                  {
                    //USE LATER TO ALLOW SIGNUP
                    /* <Card className="text-white bg-primary py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                        <CardBody className="text-center">
                          <div>
                            <h2>Sign up</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                              labore et dolore magna aliqua.</p>
                            <Button color="primary" className="mt-3" active>Register Now!</Button>
                          </div>
                        </CardBody>
                      </Card>
                    */
                  }
                </CardGroup>
              </Col>
            </Row>
          ) : (
            <Row className="justify-content-center">
              <Col md="6">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <h1>Select Store </h1>

                      <div style={{ padding: 10, width: "100%" }}>
                        <Select
                          options={this.state.stores}
                          selected={this.state.selectedStores}
                          onChange={(selected) => {
                            console.log("selected store >>", selected);

                            this.handleChangeStore(
                              [selected.label],
                              selected.value
                            );
                          }}
                        />
                      </div>
                      <Row>
                        <Col xs="6">
                          <Button
                            color="primary"
                            className="px-4"
                            onClick={() => {
                               console.log("foodcourt in login.js line 270")
                              this.props.history.push("/activeorders");
                            }}
                          >
                            Submit
                          </Button>
                        </Col>
                        <Col xs="6" className="text-right">
                          {/* <Button color="link" className="px-0">Forgot password?</Button> */}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    );
  };
  submitCredentials = async () => {
    console.log('foodcourt debug');
    var vtimestamp = generateEpochTimestamp();       
    let gngtoken = localStorage.getItem("gngtoken");
    // Peri VAPT comment
    // console.log("gngtokensubmitapp", gngtoken);
    // console.log('login credentials ',this.email, this.password, 'encoded',base64.encode(this.email + ":" + this.password) )
    
    let headers = new Headers({
      Authorization: `Basic ` + base64.encode(this.email + ":" + this.password),
      Timestamp: vtimestamp,
      Signature: generateSignature(vtimestamp, base64.encode(this.email + ":" + this.password))                

    });
    try {
      let response = await fetch(
        config.getHost() + "/api/account/store/signin/",
        {
          method: "POST",
          headers: headers,
        }
      );
      if (response.status === 200) {
        let json = await response.json();
        //to  debug Peri - foodcourt
        // if (json && json.store && json.store.id == "U3RvcmU6OGZjZWM5MjYtMGY3MC00YjEyLWJlZWYtY2E3YjM1ZTM2ZTVi") {

        //   json.store.foodcourtCashier = true;
        // }
       
      //  console.log("main json", JSON.stringify(json))
       
        //console.log("storeInformation-login", json);
        localStorage.setItem("storeInformation", JSON.stringify(json));
// Peri VAPT comment
        // console.log(JSON.stringify({ gngstoreInformation: json }));
        // console.log(JSON.stringify({ gngstoreemailid: this.email }));
        // console.log(JSON.stringify({ gngstorepassword: this.password }));
        if (json.user.isStore === true) {
          console.log(JSON.stringify({ loginMode: "store" }));
          localStorage.setItem("loginMode", "store");
          
          //Peri to change for active cash orders
        let loginMode = localStorage.getItem("loginMode");
        let storeInformation = JSON.parse(localStorage.getItem("storeInformation") || "{}");
      
        if (
          loginMode === "store" &&
          storeInformation.store &&
          storeInformation.store.foodcourtCashier === true
        ) {
           console.log("foodcourt in login.js line -335")
          localStorage.setItem("foodcourtCashier","FOODCOURT");
          this.props.history.push("/activecashorders");
          
        } else {
          localStorage.setItem("foodcourtCashier","STORE");
          localStorage.removeItem("foodcourtCashier");
          
          console.log("foodcourt in login.js line 335")
          this.props.history.push("/activeorders");
        }

        //  this.props.history.push("/activeorders");
        } else if ("merchant" in json) {
          //console.log("gng-loginMode", "merchant");
          console.log(
            JSON.stringify({
              gngloginMode: { loginMode: "merchant" },
            })
          );
          localStorage.setItem("loginMode", "merchant");
          // this.getStoreDetails();
          this.props.history.push("/ordersummary");
        } else if ("concessionaire" in json) {
          // console.log("gng-loginMode", "concessionaire");
          console.log(
            JSON.stringify({
              gngloginMode: { loginMode: "concessionaire" },
            })
          );
          localStorage.setItem("loginMode", "concessionaire");
          this.props.history.push("/ordersummary");
        } else {
          this.toggleErrorLoginModal("Please check the username and password.");
        }
      } else {
        console.log(response);
        this.toggleErrorLoginModal("Please check the username and password.");
        // throw "Incorrect username password";
      }
    } catch (error) {
      this.toggleErrorLoginModal("Something went wrong.");
    }
  };
  handleChangeStore = (selected, storeID) => {
    this.setState({
      selectedStoreID: storeID,
      selectedStores: selected,
    });
  };

  getStoreDetails = async () => {
    let params = {};
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getUserProfile",
      params
    );
    // console.log("getUserProfile", JSON.stringify(response));
    if (response.error) {
      // alert('Something went wrong. Please try again later.')
    } else {
      let res = response;

      if (res.data.userProfile.user.store === null) {
      } else {
        let res = JSON.parse(JSON.stringify(response));
        console.log(
          "getUserProfile",
          JSON.stringify(res.data.userProfile.user.merchant.stores)
        );
        let stores = [],
          store = res.data.userProfile.user.merchant.stores.edges;
        for (let i = 0; i < store.length; i++) {
          stores.push({
            label: store[i].node.name + " " + store[i].node.area,
            value: store[i].node.id,
          });
        }

        this.setState({
          showStores: true,
          stores: stores,
          storesOrinal: res.data.userProfile.user.merchant,
        });
      }
    }
  };

  toggleErrorLoginModal = (text) => {
    this.setState({
      loginModalVisible: !this.state.loginModalVisible,
      loginErrorMessage: text,
    });
  };
}
export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js